import React from 'react';
import { Clock, ListChecks, Building2, FileText, Flag, Settings, Users, CalendarDays, User, Briefcase, Mail, Phone, MapPin, Globe, DollarSign, Hash, Linkedin, CheckCircle2, Target, Trophy, XCircle } from 'lucide-react';

const ICONS = {
  Time: Clock, When: Clock, Scheduled: CalendarDays, 'Last Contact': Clock, 'Next Follow-up': CalendarDays,
  Type: ListChecks, Stage: Flag, Status: Flag,
  'Company / Contact': Building2, Company: Building2, Location: MapPin, Website: Globe,
  Contact: Users, Leads: Users, Salesperson: User, Owner: User, Name: User, Title: Briefcase, Email: Mail, Phone: Phone,
  Notes: FileText, 'Outcome / Notes': FileText,
  Action: Settings, 'Est. $/mo': DollarSign,
  'New Leads': Users, 'Leads Added': Users, Calls: Phone, Emails: Mail, LinkedIn: Linkedin, Meetings: CalendarDays,
  'Follow-ups Completed': CheckCircle2, Opportunities: Target, 'Qualified Opportunities': Target,
  Won: Trophy, 'Won Opportunities': Trophy, Lost: XCircle,
};

/** Shared premium CRM table header — one gradient/typography standard for every CRM data grid. */
export const CrmTableHead = ({ cols, dense = false, iconFor = c => ICONS[c] || (/\$/.test(c) ? DollarSign : Hash) }) => (
  <thead className="crm-thead" data-testid="crm-table-head">
    <tr>
      {cols.map(c => { const Icon = iconFor(c); return (
        <th key={c} scope="col" className={`text-left ${dense ? 'px-3' : 'px-4'} py-2.5 text-[11px] font-semibold uppercase tracking-wide text-white whitespace-nowrap transition-colors duration-150 hover:bg-white/10`}>
          <span className="inline-flex items-center gap-1.5">{Icon && <Icon className="h-3.5 w-3.5 text-white/85" aria-hidden="true" />}{c}</span>
        </th>
      ); })}
    </tr>
  </thead>
);

export default CrmTableHead;
